import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NewsletterService {
    public params = new HttpParams();

    constructor(private readonly apiService: ApiService) { }

    // listar /Newsletter
    list(params?: any): Observable<any> {
        return this.apiService.get(`/Newsletter`, params ? new HttpParams({
            fromObject: params
        }) : this.params,
        ).pipe(
            map(response => response)
        );
    }

    /**
  * Cria uma nova Newsletter
  * @param Newsletter
  * @returns Observable<any>
  */
    public store(Newsletter: any): Observable<any> {
        return this.apiService.post(`/Newsletter`, Newsletter);
    }

    // atualizar Newsletter
    update(Newsletter: any): Observable<any> {
        return this.apiService.put(`/Newsletter`, Newsletter);
    }

    toggleStatus(id: string): Observable<any> {
        return this.apiService.patch(`/Newsletter/${id}`);
    }
}
